/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgUserForClient } from './OrgUserForClient';
import {
    OrgUserForClientFromJSON,
    OrgUserForClientFromJSONTyped,
    OrgUserForClientToJSON,
    OrgUserForClientToJSONTyped,
} from './OrgUserForClient';
import type { UserHistoryOnAzure } from './UserHistoryOnAzure';
import {
    UserHistoryOnAzureFromJSON,
    UserHistoryOnAzureFromJSONTyped,
    UserHistoryOnAzureToJSON,
    UserHistoryOnAzureToJSONTyped,
} from './UserHistoryOnAzure';
import type { UserPrivateSettingsOnAzure } from './UserPrivateSettingsOnAzure';
import {
    UserPrivateSettingsOnAzureFromJSON,
    UserPrivateSettingsOnAzureFromJSONTyped,
    UserPrivateSettingsOnAzureToJSON,
    UserPrivateSettingsOnAzureToJSONTyped,
} from './UserPrivateSettingsOnAzure';

/**
 * 
 * @export
 * @interface AllUserObjects
 */
export interface AllUserObjects {
    /**
     * 
     * @type {OrgUserForClient}
     * @memberof AllUserObjects
     */
    org_user: OrgUserForClient;
    /**
     * 
     * @type {UserHistoryOnAzure}
     * @memberof AllUserObjects
     */
    user_history: UserHistoryOnAzure;
    /**
     * 
     * @type {UserPrivateSettingsOnAzure}
     * @memberof AllUserObjects
     */
    user_private_settings: UserPrivateSettingsOnAzure;
}

/**
 * Check if a given object implements the AllUserObjects interface.
 */
export function instanceOfAllUserObjects(value: object): value is AllUserObjects {
    if (!('org_user' in value) || value['org_user'] === undefined) return false;
    if (!('user_history' in value) || value['user_history'] === undefined) return false;
    if (!('user_private_settings' in value) || value['user_private_settings'] === undefined) return false;
    return true;
}

export function AllUserObjectsFromJSON(json: any): AllUserObjects {
    return AllUserObjectsFromJSONTyped(json, false);
}

export function AllUserObjectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllUserObjects {
    if (json == null) {
        return json;
    }
    return {
        
        'org_user': OrgUserForClientFromJSON(json['org_user']),
        'user_history': UserHistoryOnAzureFromJSON(json['user_history']),
        'user_private_settings': UserPrivateSettingsOnAzureFromJSON(json['user_private_settings']),
    };
}

export function AllUserObjectsToJSON(json: any): AllUserObjects {
    return AllUserObjectsToJSONTyped(json, false);
}

export function AllUserObjectsToJSONTyped(value?: AllUserObjects | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_user': OrgUserForClientToJSON(value['org_user']),
        'user_history': UserHistoryOnAzureToJSON(value['user_history']),
        'user_private_settings': UserPrivateSettingsOnAzureToJSON(value['user_private_settings']),
    };
}

